import { Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthGuard } from './core/guards/auth.guard';
import { MainGuard } from './core/guards/main.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/afterLoginPages/module-routes').then(m => m.routes),
  },
  {
    path: 'auth',
    canActivate: [MainGuard],
    loadChildren: () =>
      import('./modules/auth/auth-routes').then(m => m.routes),
  },
  {
    path: 'web',
    loadChildren: () => import('./modules/web/web-routes').then(m => m.routes),
  },
];
